export class Load extends Phaser.Scene {
  init() {
    this.load.on('start', this._renderLoader, this);

    this.overlayBg = this.add
      .rectangle(0, 0, this.game.defaultWidth, this.game.defaultHeight, 0xc9e3e8)
      .setOrigin(0);
  }

  _renderLoader() {
    if (this.content || !this.textures.exists('load')) return;
    this.scene.bringToTop(this.scene.key);
    this.content = true;

    this.bar = this.add.image(840, 385, 'load', 'loading_bar');
    this.fill = this.add.image(840, 385, 'load', 'loading_bar_fill').setOrigin(0, 0.5);
    this.fill.x -= this.fill.width / 2;

    this.add.image(492, 227, 'load', 'loading_logo').setOrigin(0, 0.5);
    this.add.image(840, 450, 'load', 'loading_text');

    this.setProgress(0);
  }

  setProgress(value) {
    this.fill.scaleX = value;
  }
}
